import DocumentsTranslationResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/DocumentService/DocumentTranslationResponse";

export default class DocumentsTranslateModel {
    langCode: string = '';
    text: string = '';
    constructor(obj?: Partial<DocumentsTranslateModel>) {
        if (obj) {
            this.langCode = obj.langCode;
            this.text = obj.text;
        }
    }
    toServerModel(): DocumentsTranslationResponse {
        return new DocumentsTranslationResponse({
            LangCode: this.langCode,
            Text: this.text
        });
    }
    fromServerModel(res: DocumentsTranslationResponse) {
        this.langCode = res.LangCode;
        this.text = res.Text;
    }
}